<div id="scrn">
  <div id="scrn-c">
    <header id="scrn-h">
        <div class="myunichoices-logo">
            <img alt="" src="assets/images/myunichoices-logo.png">
        </div>
        <div class="subtitle-strap">
            {{locale.subtitleText}}
        </div>
    </header>
    <div class="message-heading">
      {{error.title}}
    </div>
    <div class="message-text message-text-left">
      {{error.message}}
      <div class="message-text-inner" *ngIf="isPaused">{{locale.pauseTextTwo}}</div>
    </div>
    <div class="form-control" style="background: none;">
      <button *ngIf="isPaused; else otherError" class="input-control button" (click)="goToMyFJ()">{{locale.returnToMyFJText}}</button>
      <ng-template #otherError>
        <button class="input-control button" (click)="back()">{{locale.backButtonText}}</button>
      </ng-template>
    </div>
    <div class="form-control" style="background: none;">
      <button class="input-control" (click)="logout()">{{locale.logoutButtonText}}</button>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/components/_shared/error/error.component.html